module.exports = __webpack_public_path__ + "img/ProfilePicture.b3b65f8e.png";